module.exports = __webpack_public_path__ + "static/media/schlemmer.6545559c.jpg";